const ContentWrapper = ({ children, type, shift = "day", image, isDef = false, padding = "120px 10px 72px 10px" }) => {
    let defImg;
    if (isDef) {
        defImg = require(`../../../assets/images/live3/${shift}/${type}.jpg`);
    }

    const bg = image ?? defImg ?? require(`../../../assets/images/live-v2/tn/${shift}/bg.jpg`);

    return <div style={{
        backgroundSize: "100%",
        backgroundImage: `url(${bg})`,
        height: "854px",
        width: "1516px",
        padding: padding
    }} className="d-flex justify-content-center mx-0 mt-2 overflow-hidden live-v2">
        {children}
    </div>
}
export default ContentWrapper;